import { GenIcon } from 'react-icons';
export const MdHome1Filled = GenIcon({
    tag: 'svg',
    attr: { fill: 'none' },
    child: [
        {
            tag: 'path',
            attr: {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                d: 'm2 12 10-9 10 9h-3v8H5v-8H2Zm8-2.84v1.742h1.056v6.258h1.899v-8H10Z',
                fill: 'currentColor',
            },
            child: [],
        },
    ],
});
